module.exports = __webpack_public_path__ + "static/media/covidParticle.718af0b8.png";